<script setup lang="ts">
import { AccordionItem, type AccordionItemProps } from 'reka-ui'
import { cn } from '@/lib/utils'
import type { HTMLAttributes } from 'vue'

const props = defineProps<AccordionItemProps & { class?: HTMLAttributes['class'] }>()
</script>

<template>
    <AccordionItem v-bind="{ ...props, class: undefined }" :class="cn('border-b', props.class)">
        <slot />
    </AccordionItem>
</template>
